import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentDetailResponse } from '@/types/apps/component-detail.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentDetailGraphQLServiceInterface {}

type ComponentDetailGraphQLListResponse =
    GqlListResponse<ComponentDetailResponse>;

export class ComponentDetailGraphQLService
    extends BaseService
    implements ComponentDetailGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partDetail';
    }

    public getFields(): Record<string, any> {
        return {
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            deviceId: true,
            id: true,
            installingQuantity: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            partCategoryId: true,
            partDetailStatus: true,
            partGroupId: true,
            partLifeTimeHours: true,
            partSKUId: true,
            partTypeId: true,
            quantity: true,
            receivedQuantity: true,
            removedQuantity: true,
            runningHoursAtInstallation: true,
            serialNumber: true,
            totalQuantity: true,
            usageTypeId: true,
            partHealth: true,
            usageType: {
                id: true,
                name: true,
            },
            partType: {
                id: true,
                name: true,
            },
            partGroup: {
                name: true,
                id: true,
            },
            partCategory: {
                id: true,
                name: true,
            },
            partSKU: {
                id: true,
                name: true,
                partLifeTime: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ComponentDetailGraphQLListResponse> {
        return this.fetchGqlList<ComponentDetailGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentDetail', {
            userId: this.getQueryById(),
        });
    }
}
